// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".animate-custom-ping[data-v-5e37959a]{animation:ping-5e37959a 5s cubic-bezier(0,0,.2,1) infinite}@keyframes ping-5e37959a{20%,to{opacity:0;transform:scale(1.3)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
